import ric from 'ric-shim';
/*
  Invokes each function when the browser's main thread is idle.
  Functions are generally called in first-in-first-out order.
  https://developer.mozilla.org/en-US/docs/Web/API/Window/requestIdleCallback
*/
export default (...fns) => {
  fns.forEach((fn) => ric(fn));
};
